export default "__VITE_ASSET__CmRkyz8H__"